<header class="main__content__header modal-header">
    <h2 class="modal-title">Detalhes do Empréstimo</h2>
    <a class="header__btn__close" (click)="activeModal.close(true)">
        <span aria-hidden="true">X</span>
    </a>
</header>
<main class="main__content__modal modal-body">
    <section class="content__modal__header">
        <section class="row">
            <div class="col-sm-12 col-xl-6">
                <span class="content__modal__title">Empresa</span>
                <p class="content__modal__valor">{{emprestimo?.company}}</p>
            </div>
            <div class="col-sm-12 col-xl-6">
                <span class="content__modal__title">Filial</span>
                <p class="content__modal__valor">{{emprestimo?.companyBranch}}</p>
            </div>
        </section>
        <section class="row">
            <div class="col-sm-4 col-xl-3">
                <span class="content__modal__title">Contrato</span>
                <p class="content__modal__valor">{{emprestimo?.contractNumber | trim}}</p>
            </div>
            <div class="col-sm-4 col-xl-3">
                <span class="content__modal__title">Data do Crédito</span>
                <p class="content__modal__valor">{{emprestimo?.creditDate| date:'dd/MM/yyyy'}}</p>
            </div>
            <div class="col-sm-4 col-xl-6">
                <span class="content__modal__title">Situação</span>
                <p class="content__modal__valor">
                    <status [status]="emprestimo.status">
                    </status>
                    {{emprestimo?.status}}
                </p>
            </div>
        </section>
        <section class="row">
            <div class="col-xl-3">
                <span class="content__modal__title">Saldo Devedor</span>
                <p class="content__modal__valor">R$ {{emprestimo?.balanceLacking | number: "1.2-2":"pt-br"}}</p>
            </div>
            <div class="col-xl-3">
                <span class="content__modal__title">Data de Quitação</span>
                <p class="content__modal__valor" *ngIf="emprestimo?.acquittanceDate">{{emprestimo?.acquittanceDate |
                    date:'dd/MM/yyyy'}}</p>
                <p class="content__modal__valor text-center" *ngIf="!emprestimo?.acquittanceDate"> - </p>
            </div>
            <div class="col-xl-3">
                <span class="content__modal__title">Parcelas Pagas/Restantes</span>
                <p class="content__modal__valor">{{emprestimo.totalParcelCount-
                    emprestimo.totalParcelRemainingCount}}/{{emprestimo.totalParcelRemainingCount}}</p>
            </div>
        </section>
        <section class="row">
            <div class="col-xl-3">
                <span class="content__modal__title">Índice</span>
                <p class="content__modal__valor">{{emprestimo?.index}}</p>
            </div>
            <div class="col-xl-3">
                <span class="content__modal__title">Motivo de Concessão</span>
                <p class="content__modal__valor">{{emprestimo?.reason}}</p>
            </div>
            <div class="col-xl-3">
                <span class="content__modal__title">Taxa de Concessão</span>
                <p class="content__modal__valor">R$ {{emprestimo?.concessionValue | number: "1.2-2":"pt-br"}}</p>
            </div>
            <div class="col-xl-3">
                <span class="content__modal__title">Valor IOF</span>
                <p class="content__modal__valor">R$ {{emprestimo?.taxValue | number: "1.2-2":"pt-br"}}</p>
            </div>
        </section>
        <section class="row">
            <div class="col-xl-3">
                <span class="content__modal__title">Valor Operação</span>
                <p class="content__modal__valor">R$ {{emprestimo?.operationValue | number: "1.2-2":"pt-br"}}</p>
            </div>
            <div class="col-xl-3">
                <span class="content__modal__title">Taxa de Juros</span>
                <p class="content__modal__valor">{{emprestimo?.interestValue | number: "1.2-2":"pt-br"}} %</p>
            </div>
            <div class="col-xl-3">
                <span class="content__modal__title">Percentual de Desconto</span>
                <p class="content__modal__valor">{{emprestimo?.discount | number: "1.2-2":"pt-br"}} %</p>
            </div>
            <div class="col-xl-3">
                <span class="content__modal__title">Teto de Prestação</span>
                <p class="content__modal__valor">R$ {{emprestimo?.ceilingParcel | number: "1.2-2":"pt-br"}}</p>
            </div>
        </section>
    </section>
    <section class="content__modal__table">
        <section class="modal__table__header">
            <h3 class="header__title">
                Extrato Detalhado
            </h3>
            <span class="header__value">
                Total de
                <span>{{listaEmprestimoDetalhado.length}} </span>
                resultados
            </span>
        </section>
        <section class="table-responsive modal__table__main">
            <table class="table table-sm table-hover table-bordered">
                <thead>
                    <tr class='tag'>
                        <th rowspan='2' class="text-center">Data</th>
                        <th colspan="3" class="text-center">Lançamentos</th>
                        <th colspan="4" class="text-center">Saldo</th>
                        <th colspan="6" class="text-center">Valor Atual</th>
                        <th rowspan='2' class="text-center">Índice</th>
                        <th rowspan='2' class="text-center">Cotação</th>
                    </tr>
                    <tr>
                        <th scope="col">Nº</th>
                        <th scope="col">Tipo</th>
                        <th scope="col">Sit.</th>
                        <th scope="col">Anterior</th>
                        <th scope="col">Correção</th>
                        <th scope="col">Juros</th>
                        <th scope="col">Corrigido</th>
                        <th scope="col">Amortização</th>
                        <th scope="col">Correção</th>
                        <th scope="col">Juros</th>
                        <th scope="col">Previsto</th>
                        <th scope="col">Realizado</th>
                        <th scope="col">Atual</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class='informacao' *ngFor="let parcel of getItensDaPagina()">
                        <td>{{ parcel.expiresDate | date:'dd/MM/yyyy'}}</td>
                        <td>{{ parcel.number }}</td>
                        <td>{{ parcel.type }}</td>
                        <td>{{ parcel.status }}</td>
                        <td [ngClass]="parcel.previousBalance < 0 ? 'valorNegativo' : '' ">
                            R$ {{ parcel.previousBalance | number: "1.2-2":"pt-br"}}
                        </td>
                        <td [ngClass]="parcel.monetaryCorrectionBalance < 0 ? 'valorNegativo' : '' ">
                            R$ {{ parcel.monetaryCorrectionBalance | number: "1.2-2":"pt-br"}}
                        </td>
                        <td [ngClass]="parcel.interestBalance < 0 ? 'valorNegativo' : '' ">
                            R$ {{ parcel.interestBalance | number: "1.2-2":"pt-br"}}
                        </td>
                        <td [ngClass]="parcel.correctBalance < 0 ? 'valorNegativo' : '' ">
                            R$ {{ parcel.correctBalance | number: "1.2-2":"pt-br"}}
                        </td>
                        <td [ngClass]="parcel.amortizationParcel < 0 ? 'valorNegativo' : '' ">
                            R$ {{ parcel.amortizationParcel | number: "1.2-2":"pt-br"}}
                        </td>
                        <td [ngClass]="parcel.monetaryCorrectionParcel < 0 ? 'valorNegativo' : '' ">
                            R$ {{ parcel.monetaryCorrectionParcel | number: "1.2-2":"pt-br"}}
                        </td>
                        <td [ngClass]="parcel.interestParcel < 0 ? 'valorNegativo' : '' ">
                            R$ {{ parcel.interestParcel | number: "1.2-2":"pt-br"}}
                        </td>
                        <td [ngClass]="parcel.foreseenParcel < 0 ? 'valorNegativo' : '' ">
                            R$ {{ parcel.foreseenParcel | number: "1.2-2":"pt-br"}}
                        </td>
                        <td [ngClass]="parcel.accomplishedParcel < 0 ? 'valorNegativo' : '' ">
                            R$ {{ parcel.accomplishedParcel | number: "1.2-2":"pt-br"}}
                        </td>
                        <td [ngClass]="parcel.actualBalance < 0 ? 'valorNegativo' : '' ">
                            R$ {{ parcel.actualBalance | number: "1.2-2":"pt-br"}}
                        </td>
                        <td>
                            <span *ngIf="parcel.index">{{ parcel.index}}</span>
                            <span *ngIf="!parcel.index"> - </span>
                        </td>
                        <td>
                            <span *ngIf="parcel.indexPercent">{{ parcel.indexPercent | number: "1.2-2":"pt-br"}}</span>
                            <span *ngIf="!parcel.indexPercent"> - </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </section>
        <section class="modal__table__footer">
            <ngb-pagination [(page)]="paginaAtual" [pageSize]="itensPorPagina"
                [collectionSize]="listaEmprestimoDetalhado.length"></ngb-pagination>
        </section>
    </section>
</main>